import React, { type FC, useMemo } from "react";
import { BankDropdown } from "../BankDropdown";
import { FormattedMessage } from "react-intl";
import { GQL } from "@binale-tech/shared";
import { useLocation, useParams } from "react-router-dom";
import { AppRoutes, getRoute } from "@domain/routing/routeConstants";
import { ModuleNav, type NavItem } from "./ModuleNav";

export const ModuleBankLinks: FC<{ onOpenSettings: (pk: GQL.IProductKey) => void }> = ({ onOpenSettings }) => {
    const { pathname = "" } = useLocation();
    const { uuid } = useParams<"uuid">();
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: "selector",
                label: <BankDropdown selectedRecordGroup={uuid} />,
            },
            {
                key: AppRoutes.bankTemplates,
                to: getRoute(AppRoutes.bankTemplates, { uuid }),
                label: <FormattedMessage id="app.titles.templates" />,
            },
            {
                key: "settings",
                onClick: () => onOpenSettings(GQL.IProductKey.Bank),
                label: <FormattedMessage id="app.titles.settings" />,
            },
        ],
        [uuid, onOpenSettings],
    );
    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
